import React from 'react';
import {createHashRouter, Navigate,RouterProvider} from 'react-router-dom';

import AppLayout from '../Layout/index.jsx';
import Home from '../pages';
import Ask from '../pages/Ask';
import AskDetail from '../pages/Ask/detail'
import Help from '../pages/Help';
import Us from '../pages/Us';

const router = createHashRouter([
    {
        path: '/',
        element: <AppLayout />,
        children: [
            {
                index: true,
                element: <Navigate to="/home" />,
            },
            {
                path: '/home',
                element: <Home />,
            },
            {
                path: '/ask',
                element: <Ask />,
            },
            {
                path: '/ask/:id',
                element: <AskDetail />,
            },
            {
                path: '/help',
                element: <Help />,
            },
            {
                path: '/us',
                element: <Us />,
            },
        ],
    },
]);

const RouterNode = () => <RouterProvider router={router} />;

export default RouterNode;
